var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.debug === 'true' || _vm.debug === true)?_c('span',[_vm._v(_vm._s(_vm.version))]):_vm._e(),_c('router-link',{attrs:{"to":{
      name: _vm.data.item.idEtapa == 79 ?'resumenClinicoSeguimientoVisible': _vm.data.item.idEtapa == 80 ?'MetodosDePagoPTIVisible': _vm.data.item.idEtapa == 81 ?'DistribucionCobroPTIVisible': '',
      params:
      _vm.data.item.idEtapa == 79 ?
      {
       idPti:        _vm.data.item.idPti,
       idSolicitud:  _vm.data.item.idSolicitud,
       opcion:       _vm.data.item.opcionAceptada}:

      _vm.data.item.idEtapa === 80?
      {
      idPti:            _vm.data.item.idPti,
      idSolicitudEtapa: _vm.data.item.idSolicitudEtapa,
      idTicket:      _vm.data.item.idSolicitud,
      idEtapa:          _vm.data.item.idEtapa,
      opcion:           _vm.data.item.opcionAceptada
      }:
       _vm.data.item.idEtapa === 81?
      {
      idPti:            _vm.data.item.idPti,
      idSolicitudEtapa: _vm.data.item.idSolicitudEtapa,
      idTicket:      _vm.data.item.idSolicitud,
      idEtapa:          _vm.data.item.idEtapa
      }:{},
    }}},[_c('p',{staticClass:"letraColorAzulPrincipal letraEstiloNegrita"},[_vm._v(" "+_vm._s(_vm.data["item"].nombrePaciente)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }